import { c as _c } from "react/compiler-runtime";
import { Divider } from '@/app/components/divider';
import { HeaderContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/header-content';
import { HighlightedContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/highlighted-content';
import { ImagesGalleryContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/images-gallery-content';
import { SingleImageContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/single-image-content';
import { TextContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/text-content';
import type { ContentRowProps, ContentRowWithComponent } from '@/app/lcv/components/sections/news-activities/details/content-rows/types';
import { YouTubeContent } from '@/app/lcv/components/sections/news-activities/details/content-rows/youtube-content';
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { NEWS_CONTENT_ROWS_COMPONENTS } from '@/services/news-activities/const';
import type { ComponentNewsHeader, ComponentNewsHighlighted, ComponentNewsImages, ComponentNewsSingleImage, ComponentNewsTextContent, ComponentNewsYoutube } from '@/types/tis-cms/types';
export const NewsContentRow = t0 => {
  const $ = _c(19);
  const {
    data,
    title,
    index,
    testId
  } = t0;
  if (!data) {
    return null;
  }
  const component = (data as ContentRowWithComponent).__component;
  if (!component) {
    return null;
  }
  switch (component) {
    case NEWS_CONTENT_ROWS_COMPONENTS.textContent:
      {
        const t1 = data as ComponentNewsTextContent;
        let t2;
        if ($[0] !== t1) {
          t2 = <DetailsContentRow contentClassName="space-y-4 md:space-y-6 md:px-12"><TextContent data={t1} /></DetailsContentRow>;
          $[0] = t1;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        return t2;
      }
    case NEWS_CONTENT_ROWS_COMPONENTS.header:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Divider />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        const t2 = data as ComponentNewsHeader;
        let t3;
        if ($[3] !== t2) {
          t3 = <DetailsContentRow contentClassName="space-y-4 md:space-y-6 md:px-12"><>{t1}<HeaderContent data={t2} /></></DetailsContentRow>;
          $[3] = t2;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        return t3;
      }
    case NEWS_CONTENT_ROWS_COMPONENTS.singleImage:
      {
        const t1 = data as ComponentNewsSingleImage;
        const t2 = `${testId}-single-image-${index}`;
        let t3;
        if ($[5] !== t1 || $[6] !== t2 || $[7] !== title) {
          t3 = <SingleImageContent data={t1} title={title} testId={t2} />;
          $[5] = t1;
          $[6] = t2;
          $[7] = title;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        return t3;
      }
    case NEWS_CONTENT_ROWS_COMPONENTS.images:
      {
        const t1 = data as ComponentNewsImages;
        let t2;
        if ($[9] !== index || $[10] !== t1 || $[11] !== testId || $[12] !== title) {
          t2 = <ImagesGalleryContent data={t1} title={title} index={index} testId={testId} />;
          $[9] = index;
          $[10] = t1;
          $[11] = testId;
          $[12] = title;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        return t2;
      }
    case NEWS_CONTENT_ROWS_COMPONENTS.highlighted:
      {
        const t1 = data as ComponentNewsHighlighted;
        let t2;
        if ($[14] !== t1) {
          t2 = <HighlightedContent data={t1} />;
          $[14] = t1;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        return t2;
      }
    case NEWS_CONTENT_ROWS_COMPONENTS.youtube:
      {
        const t1 = data as ComponentNewsYoutube;
        let t2;
        if ($[16] !== t1 || $[17] !== title) {
          t2 = <YouTubeContent data={t1} title={title} />;
          $[16] = t1;
          $[17] = title;
          $[18] = t2;
        } else {
          t2 = $[18];
        }
        return t2;
      }
    default:
      {
        return null;
      }
  }
};